// src/hooks/useProjects.js
import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import { setProjects, setError, clearProjects } from '../features/projectsSlice';

const API_URL = 'https://api-4h4srbodqa-uc.a.run.app/api';
// const API_URL = 'http://localhost:4000/api';

export const useProjects = (userId, role) => {
  const dispatch = useDispatch();

  return useQuery({
    queryKey: ['projects', userId, role],
    queryFn: async () => {
      const { data } = await axios.get(`${API_URL}/user/${userId}/role-projects?role=${role}`);
      // const { data } = await axios.get(`http://localhost:4000/api/user/${userId}/role-projects?role=${role}`);
      console.log('Raw API response:', data); // Log the raw API response
      return data;
    },
    onSuccess: (data) => {
      console.log('Setting projects in Redux:', data);
      dispatch(setProjects(data));
    },
    onError: (error) => {
      console.error('Fetch error:', error);
      dispatch(setError(error.message));
    },
    staleTime: 5 * 60 * 1000,
    refetchInterval: 30000,
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  });
};